import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CriusesFill__IconWrapper",
  componentId: "sc-18x06jf-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M12.02 1.5a.5.5 0 0 1 .492.41l.008.09v1.44h2.25a.5.5 0 0 1 .35.143l.062.074L16.786 6 19.21 6a.5.5 0 0 1 .497.446l.002.084-.254 4.167 2.736.803a.5.5 0 0 1 .35.58l-.025.082-3.437 8.809c.137.097.265.129.441.129.3 0 .457-.092.762-.443l.11-.13c.552-.665.916-.927 1.628-.927a.5.5 0 1 1 0 1c-.294 0-.449.09-.751.439l-.11.13c-.554.667-.921.931-1.639.931-.662 0-1.026-.224-1.517-.783l-.129-.15c-.38-.454-.537-.567-.864-.567-.295 0-.452.091-.758.443l-.108.127c-.556.668-.92.93-1.634.93-.659 0-1.02-.223-1.509-.783l-.125-.147c-.381-.457-.538-.57-.866-.57-.295 0-.452.091-.758.443l-.108.127c-.556.668-.92.93-1.634.93-.658 0-1.021-.224-1.512-.783l-.125-.146c-.383-.458-.54-.571-.863-.571-.29 0-.444.09-.746.439l-.11.13c-.554.667-.92.931-1.634.931-.659 0-1.02-.223-1.509-.783l-.125-.147c-.381-.457-.538-.57-.866-.57a.5.5 0 1 1 0-1c.659 0 1.02.223 1.509.783l.125.147c.381.457.538.57.866.57a.68.68 0 0 0 .455-.143l-3.44-8.795a.5.5 0 0 1 .244-.63l.08-.032 2.727-.8-.245-4.17a.5.5 0 0 1 .415-.523L4.84 6l2.423-.001 1.605-2.342a.5.5 0 0 1 .315-.207l.097-.01h2.24V2a.5.5 0 0 1 .5-.5"
  }), React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M12.03 9.54a.5.5 0 0 1 .492.41l.008.09-.009 9.62c-.152-.04-.319-.06-.511-.06-.184 0-.344.017-.49.055l.01-9.615a.5.5 0 0 1 .5-.5"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.light")(themeProps),
    d: "m18.678 7-.208 3.408-6.3-1.848-.14-.02-.15.02-6.309 1.851L5.37 7z"
  })));
}
const CriusesFill = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CriusesFill);
export default Memo;